var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAppleBw = function SvgAppleBw(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.23 6.62c.88 0 1.97-.61 2.63-1.42.59-.74 1.02-1.77 1.02-2.8 0-.14-.01-.28-.04-.39-.97.04-2.15.67-2.85 1.53-.56.65-1.06 1.67-1.06 2.71 0 .15.02.31.04.36.06.01.16.03.26.03ZM9.15 22c1.2 0 1.73-.83 3.22-.83s1.85.8 3.18.8 2.18-1.25 3.01-2.47c.93-1.4 1.31-2.77 1.33-2.84-.09-.03-2.59-1.08-2.59-4.04 0-2.57 1.97-3.73 2.08-3.81-1.31-1.93-3.29-1.98-3.84-1.98-1.47 0-2.66.92-3.42.92-.81 0-1.89-.86-3.16-.86-2.42 0-4.87 2.06-4.87 5.95 0 2.42.91 4.97 2.04 6.62.96 1.4 1.8 2.54 3.01 2.54Z"
  })));
};
export default SvgAppleBw;